import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface User  {
  user: {
    idUser: string,
    email: string,
    roles: [
      string
    ],
    name: string,
    lastName: string,
    documentNumber: string,
    status: string,
    dateCreated: number,
    dateLastupdate: number
  },
  token: {
    type: string,
    token: string
  }
}

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor() { }

  user = new BehaviorSubject(null);

  user$ = this.user.asObservable();

  newUser(user: User){
    this.user.next(user);
  }

  getUser(){
    return this.user.value;
  }

}
